module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/ostern-01fc853e7e21181b9a725e095045d8b0.svg";